import React, {FunctionComponent} from "react";
import { IQuestion } from "../interfaces";

interface BlocQuestionsProps {
  items: IQuestion[];
  baseLangUrl: string;
}

const BlocQuestions: FunctionComponent<BlocQuestionsProps> = ({items, baseLangUrl}) => {
  let nbQPerColumn = 0;
  let add = 0;
  if (items.length % 2 === 0) {
    nbQPerColumn = items.length / 2;
  } else {
    nbQPerColumn = (items.length - 1) / 2;
    add = 1;
  }

  function forQuestions(startIndex: number, nbSuperior: number): JSX.Element[] {
    const arrayElement: JSX.Element[] = [];
    for (let i = startIndex; i < nbSuperior; i++) {
      const question = items[i];
      arrayElement.push(
        <p key={i}>
          <a className="text-black cursor-pointer" href={`/${baseLangUrl}/help/q-${question.slug}/${question.id}`}>
            - {question.question}
          </a>
        </p>
      )
    }
    return arrayElement;
  }


  return (
    <div className="faq-list-questions mt2">
      <div className="flex-grow-1">
        {forQuestions(0, nbQPerColumn + add)}
      </div>
      <div className="flex-grow-1">
        {forQuestions(nbQPerColumn + add, items.length)}
      </div>
    </div>
  );
};

export default BlocQuestions;